import React,{useState} from 'react'
import {useTypewriter ,Cursor} from 'react-simple-typewriter'

export default function () {
    const [text,helper] = useTypewriter({
        words: ['I am a full-stack developer!', 'Web, App and ML/DL Enthusiast'],
        loop: 0,
        typeSpeed: 300
    }) 
  return (
    <div className='flex flex-col items-center justify-center h-[100vh]'>
        <div className='text-white uppercase'>
            // Hi I'm Haaris 👋🏼, A...
        </div>
        <div className="code-font flex text-4xl text-white">
            &#123;
        <div className='text-[#E6DB74]'>{text}<Cursor /></div>
            &#125;
      </div>
    </div>
    
  )
}
